import Axios from "axios";
import config from "../app.config";

export var userSignature;
export default userSignature = {
    getUserSignature,
    createUserSignature,
    deleteUserSignature,
    updateUserSignature
}

async function getUserSignature() {
    return await Axios.get(`${config.LOCAL_API_URL}/user-signature`)
      .then(response => {
        if (response.data) {
          return Promise.resolve(response.data);
        } else {
          return Promise.reject(response);
        }
      }).catch(error => {
        return Promise.reject(error);
      })
  }

  async function createUserSignature(data) {
    return await Axios.post(`${config.LOCAL_API_URL}/createUserSignature`, data)
      .then(response => {
        if (response.data) {
          return Promise.resolve(response.data);
        } else {
          return Promise.reject(response);
        }
      }).catch(error => {
        return Promise.reject(error);
      })
  }

  async function deleteUserSignature(params) {
    return await Axios.delete(`${config.LOCAL_API_URL}/deleteUserSignature`, {data : {ids: params}})
      .then(response => {
        if (response.data) {
          return Promise.resolve(response.data);
        } else {
          return Promise.reject(response);
        }
      }).catch(error => {
        return Promise.reject(error);
      })
  }

  async function updateUserSignature(data) {
    return await Axios.put(`${config.LOCAL_API_URL}/updateUserSignature`, data)
      .then(response => {
        if (response.data) {
          return Promise.resolve(response.data);
        } else {
          return Promise.reject(response);
        }
      }).catch(error => {
        return Promise.reject(error);
      })
  }

